export default __webpack_public_path__ + "static/media/alert_mc7b.d07af81b.svg";